import React, { FC } from 'react';
// import { useApplication } from '../../../../context/ApplicationContext';
import { APIS } from '../../../../lib/constants/apis';

import BreadCrumbAntrag from './BreadCrumbAntrag';
import BreadCrumbVerwendungsnachweis from './BreadCrumbVerwendungsnachweis';

const ApplicationBreadcrumbs: FC<{ api: string }> = ({ api }) => {
	// const { application } = useApplication();

	const RenderContent = () => {
		switch (api) {
			case APIS.Antrag:
				return <BreadCrumbAntrag />;
			case APIS.Verwendungsnachweis:
				return <BreadCrumbVerwendungsnachweis />;

			default:
				return <></>;
		}
	};

	return <RenderContent />;
};

export default ApplicationBreadcrumbs;
